import React from 'react';
import { AlertIcon } from 'taboola-ultimate-ui';
import { EVENT_ICONS, TYPE_INDICATORS } from 'modules/PixelTester/config/pixelTesterConsts';
import { isS2sIntegration } from 'modules/PixelTester/utils/utils';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { CONVERSION_TYPE } from 'modules/tracking/config';
import styles from './eventCardHeader.module.scss';

export const formatTimestampToTodayString = timestampStr => {
    const timestamp = Number(timestampStr);
    if (!Number.isFinite(timestamp)) return null;

    return new Date(timestamp).toLocaleString(undefined, {
        year: 'numeric',
        month: 'long',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    });
};

export const EventCardHeader = ({ conversionName, eventType, eventData, isAutomaticallyFired }) => {
    const { eventName, eventTime, issues, pixelIntegrationType } = eventData;
    const isUrlEvent = eventType === CONVERSION_TYPE.BASIC;
    const IconComponent = EVENT_ICONS[eventType];
    const showAlert = issues?.worstIssueType !== TYPE_INDICATORS.OK;
    const cardErrorType = issues?.worstIssueType === TYPE_INDICATORS.ERROR ? 'error-icon' : 'alert-icon';
    const isServerIntegration = isS2sIntegration(pixelIntegrationType);

    return (
        <div className={styles['header-container']}>
            <div className={styles['icon-title-container']}>
                <div className={styles['icon-background']}>
                    <IconComponent className={styles['icon']} />
                </div>
                <div className={styles['title-container']}>
                    {conversionName ? (
                        <span className={styles['title-text']}>{conversionName}</span>
                    ) : isAutomaticallyFired ? (
                        <div className={styles['source-label']}>
                            <FormattedMessage
                                id="pixel.tester.automatic.event.label"
                                defaultMessage="Automatically Fired"
                            />
                        </div>
                    ) : (
                        <FormattedMessage
                            id="pixel.tester.undefined.event.title"
                            defaultMessage="Undefined conversion"
                            className={styles['undefined-title-text']}
                        />
                    )}
                    {isUrlEvent ? (
                        <FormattedMessage
                            id="pixel.tester.url.subtitle"
                            defaultMessage="URL"
                            className={styles['subtitle-text']}
                        />
                    ) : (
                        <FormattedMessage
                            id="pixel.tester.event.subtitle"
                            defaultMessage="Event: {eventName}"
                            values={{ eventName }}
                            className={styles['subtitle-text']}
                        />
                    )}
                </div>
            </div>
            <div className={styles['date-issue-container']}>
                {showAlert && <AlertIcon className={styles[cardErrorType]} aria-label={cardErrorType} role="img" />}
                {isServerIntegration ? (
                    <FormattedMessage
                        id="pixel.tester.event.indication.server"
                        className={styles['integration-source']}
                        defaultMessage="Server"
                    />
                ) : (
                    <FormattedMessage
                        id="pixel.tester.event.indication.pixel"
                        className={styles['integration-source']}
                        defaultMessage="Pixel"
                    />
                )}

                <span className={styles['divider']} />
                <div className={styles['date']}>{formatTimestampToTodayString(eventTime)}</div>
            </div>
        </div>
    );
};
